export default `
<style>
*, *::before, *::after {
  box-sizing: border-box;
  word-break: break-word;
}

html,body {
  height: 100%;
}

html,body,p {
  margin:0;
  padding:0;
}

  img {
    display: block;
  }

  body {
    line-height: 1.5715;
  }

body {
  line-height: 1.5715;
}

h1, h2, h3, h4, h5, h6 {
  margin-top: 0;
  margin-bottom: 0.5em;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
}

.rip-mm-row, .row {
  width: 100%;
}

.rip-mm-row-content, .row-content {
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  min-width: 0;
}

.rip-mm-col, .col {
  text-align: center;
}

.rip-mm-col-md-12, .col-md-12 {
  display: block;
  flex: 0 0 100%;
  max-width: 100%;
}

.rip-mm-col-md-9, .col-md-9 {
  display: block;
  flex: 0 0 75%;
  max-width: 75%;
}

.rip-mm-col-md-8, .col-md-8 {
  display: block;
  flex: 0 0 66.66666666%;
  max-width: 66.66666666%;
}

.rip-mm-col-md-6, .col-md-6 {
  display: block;
  flex: 0 0 50%;
  max-width: 50%;
}


.rip-mm-col-md-4, .col-md-4 {
  display: block;
  flex: 0 0 33.33333333%;
  max-width: 33.33333333%;
}

.rip-mm-col-md-3, .col-md-3 {
  display: block;
  flex: 0 0 25%;
  max-width: 25%;
}

.rip-mm-col-md-2, .col-md-2 {
  display: block;
  flex: 0 0 16.666666666%;
  max-width: 16.666666666%;
}
.rip-mm-side-cnt-wrapper {
  width: 100%;
  display: flex;
  align-items: start;
  flex-direction: column;
}

.rip-mm-side-cnt-wrapper.small {
  width: 65%;
}

.rip-mm-side-cnt-wrapper.medium {
  width: 50%;
}

.rip-mm-side-cnt-wrapper.large {
  width: 35%;
}

.rip-mm-side-img-wrapper.small {
  width: 35%;
}

.rip-mm-side-img-wrapper.medium {
  width: 50%;
}

.rip-mm-side-img-wrapper.large {
  width: 65%;
}
@media (max-width:600px){
  .rip-mm-row-stack .rip-mm-col-md-2, .row-stack .col-md-2 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .rip-mm-row-stack .rip-mm-col-md-3, .row-stack .col-md-3 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .rip-mm-row-stack .rip-mm-col-md-4, .row-stack .col-md-4 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .rip-mm-row-stack .rip-mm-col-md-6, .row-stack .col-md-6 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .rip-mm-row-stack .rip-mm-col-md-8, .row-stack .col-md-8 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .rip-mm-row-stack .rip-mm-col-md-9, .row-stack .col-md-9 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .rip-mm-hide-on-mobile {
    display: none;
  }
}

.rip-form-input {
    outline: none;
  }
.rip-form-input.error {
  border-color: #ff4d4f;
}
.rip-form-error .error {
  color: #ff4d4f;
}
</style>
`;